var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33343 26.6668C4.81273 26.1461 4.81274 25.3018 5.33343 24.7811L24.7811 5.33344C25.3018 4.81274 26.1461 4.81273 26.6668 5.33343V5.33343C27.1875 5.85413 27.1875 6.69835 26.6668 7.21905L7.21905 26.6668C6.69835 27.1875 5.85413 27.1875 5.33343 26.6668V26.6668Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6666 26.6668C27.1873 26.1461 27.1873 25.3018 26.6666 24.7811L7.21885 5.33344C6.69815 4.81274 5.85393 4.81273 5.33323 5.33343V5.33343C4.81253 5.85413 4.81253 6.69835 5.33323 7.21905L24.7809 26.6668C25.3016 27.1875 26.1459 27.1875 26.6666 26.6668V26.6668Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRound);
export default __webpack_public_path__ + "static/media/icon_cross_round.2cf59709d4c698f2a00ab6abb05363ce.svg";
export { ForwardRef as ReactComponent };